










































import Vue from 'vue';
import axios from 'axios';
import { ErrorResponse } from '@/api/dto/Error';
import VariableInput from '@/components/util/VariableInput.vue';
import {
  mailAddressLengthLimit,
  mailAddressConstraintErrorMessage, 
  mailAddressRegExp,
  passwordConstraintMessage,
  passwordConstraintErrorMessage, 
  passwordRegExp, 
} from './constraint';
import FooterSimple from '@/parts/common/FooterSimple.vue';
import { updateAuthCodeFlag } from '@/jwt';
import { Dictionary } from 'vue-router/types/router';

export default Vue.extend({
  name: 'Login',
  components: {
    VariableInput,
    FooterSimple,
  },
  watch: {
    'accountData.mail'(mailAddress: string) {
      this.inputs['mail'].error = (mailAddress.length <= mailAddressLengthLimit && mailAddressRegExp.test(mailAddress)) ? '' : mailAddressConstraintErrorMessage;
    },
    'accountData.password'(password: string) {
      this.inputs['password'].error = passwordRegExp.test(password) ? '' : passwordConstraintErrorMessage;
    },
  },
  created (){
      this.accountData.mail = this.$route.params.mail ? this.$route.params.mail : "";
      this.accountData.password =  this.$route.params.password ? this.$route.params.password : "";
    },
  data() {
    return {
      accountData: {
        mail: '',
        password: '',
      },
      inputs: {
        'mail': {name: 'メールアドレス', type: 'text', placeholder: 'メールアドレス', error: '' },
        'password': { name: 'パスワード', type: 'password', constraint: passwordConstraintMessage, placeholder: 'パスワード', error: '' },
      },
      generalError: '',
    }
  },
  computed: {
    /**
     * どれかエラーがあればdisabled
     */
    submitDisabled(): boolean {
      return !(this.accountData.mail.length <= mailAddressLengthLimit && mailAddressRegExp.test(this.accountData.mail) 
        && passwordRegExp.test(this.accountData.password));
    },
  },
  methods: {
    async onClickSubmit() {
      try {
        await this.$store.dispatch('login', { 
          mailAddress: this.accountData.mail,
          password: this.accountData.password,
        });

        // 二要素認証の設定の有無を確認
        if (!this.$store.getters.userProfile.isTwoFactor) {
          // 未設定ならフラグを認証済みフラグをtrueにして、トップページに遷移
          updateAuthCodeFlag("true");
          this.$router.push('/', () => { });
          this.$emit('pushPath', '/');
        } else {
          // 設定中なら番号認証画面に遷移する
          this.onPushPath('/login/number/auth');
        }
      } catch (e) {
        if(axios.isAxiosError(e) && e.response){
          var resError = e.response.data as ErrorResponse;
          this.generalError = resError.message;
        }
      }
    },
    onPushPath(path: string) {
    this.$router.push(path, () => {}); // eslint-disable-line
    this.$emit('pushPath', path);
    },
    onPushName(routeName: string,params: Dictionary<string> | undefined) {
      this.$router.push({
        name: routeName,
        params: params,
      });

    }
  }
})
